import React from 'react';
import WorkoutApp from './components/WorkoutApp';
export function App() {
  return <div className="w-full min-h-screen bg-gray-100" data-id="element-0">
      <WorkoutApp data-id="element-1" />
    </div>;
}